import { render, staticRenderFns } from "./workspace_actions.vue?vue&type=template&id=8e3e054c"
import script from "./workspace_actions.vue?vue&type=script&lang=js"
export * from "./workspace_actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports